import type { DateTextProps } from '~/features/temporal';
import { Span } from '@workramp/ui';
import { DateText } from '~/features/temporal';

export interface DateCellProps extends Omit<DateTextProps, 'date'> {
  date?: number | string | Date | null;
}

export function DateCell({ date, ...props }: DateCellProps) {
  return <Span size={1}>{date ? <DateText date={date} {...props} /> : '--'}</Span>;
}
